<template>
<b-nav-item-dropdown :text="$i18n.locale" right style="padding-bottom: 2px;">
    <b-dropdown-item href="#" @click="setLanguage('de')" v-show="$i18n.locale !== 'de'">de</b-dropdown-item>
    <b-dropdown-item href="#" @click="setLanguage('fr')" v-show="$i18n.locale !== 'fr'">fr</b-dropdown-item>
    <b-dropdown-item href="#" @click="setLanguage('it')" v-show="$i18n.locale !== 'it'">it</b-dropdown-item>
</b-nav-item-dropdown>
</template>

<script>
export default {
    name: "language",
    data() {
        return {};
    },
    computed: {
        user() {
            return this.$store.state.userStore.user;
        }
    },
    methods: {
        setLanguage: async function(lang) {
            // da die Route den gleichen namen hat wird die Datatablen nicht refreshed ..
            // ergänzung: mit <router-view :key="$route.fullPath"></router-view> in app.vue gehts
            this.$router.push({ name: this.$route.name, params: { lang: lang } });
        },
    },
    created() {}
};
</script>